export default "__VITE_ASSET__Cr$LURXJ__"